"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var EVENT_TYPES = {
    RESUMING: 'resuming',
    SUSPENDING: 'suspending',
};
exports.lifecycleResults = {};
var UWPLifecycle = (function (_super) {
    __extends(UWPLifecycle, _super);
    function UWPLifecycle(winRtBridge, messenger) {
        var _this = _super.call(this) || this;
        _this.winRtBridge = winRtBridge;
        _this.messenger = messenger;
        _this.resumeCallbacks = [];
        _this.suspendCallbacks = [];
        _this.winRtBridge.addLifecycleEventListener(EVENT_TYPES.RESUMING, function () {
            var resumePromises = _this.resumeCallbacks.map(function (resumeCallback) { return resumeCallback(); });
            var finaliseResume = function () {
                _this.messenger.sendMessage({
                    command: 'loadComplete',
                });
            };
            exports.lifecycleResults.resumeFinalised = Promise.all(resumePromises)
                .then(finaliseResume)
                .catch(finaliseResume);
        });
        _this.winRtBridge.addLifecycleEventListener(EVENT_TYPES.SUSPENDING, function (event) {
            var suspendPromises = _this.suspendCallbacks.map(function (suspendCallback) { return suspendCallback(); });
            var finaliseSuspend = function () {
                event.suspendingOperation.getDeferral().complete();
            };
            exports.lifecycleResults.suspendFinalised = Promise.all(suspendPromises)
                .then(finaliseSuspend)
                .catch(finaliseSuspend);
        });
        return _this;
    }
    UWPLifecycle.prototype.onResuming = function (eventHandler) {
        this.resumeCallbacks.push(eventHandler);
        return false;
    };
    UWPLifecycle.prototype.onSuspending = function (eventHandler) {
        this.suspendCallbacks.push(eventHandler);
        return false;
    };
    return UWPLifecycle;
}(client_lib_js_player_addons_common_player_1.Lifecycle));
exports.UWPLifecycle = UWPLifecycle;
